var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-divider m-padding"},[_c('p'),_c('div',{style:({color: _vm.color })},[_vm._v(_vm._s(_vm.title))]),_c('p')])}
var staticRenderFns = []

export { render, staticRenderFns }